'use client'
import { useState } from 'react'

// 模拟评价数据
const mockReviews = [
  {
    id: '1',
    user: {
      name: 'John Doe',
      avatar: '#e0e0e0',
    },
    rating: 5,
    content: '非常好用的产品，外观设计很漂亮，续航能力也很强。',
    images: ['#f0f0f0', '#e0e0e0', '#d0d0d0'],
    date: '2024-03-15',
    hasVideo: false,
  },
  {
    id: '2',
    user: {
      name: 'Jane Smith',
      avatar: '#d0d0d0',
    },
    rating: 4,
    content: '整体不错，就是价格稍微有点贵。包装很好，物流很快。',
    images: ['#e0e0e0'],
    date: '2024-03-14',
    hasVideo: true,
  },
]

const ProductReviews = () => {
  const [showMediaOnly, setShowMediaOnly] = useState(false)
  const [expanded, setExpanded] = useState<Record<string, boolean>>({})

  const toggleExpand = (id: string) => {
    setExpanded((prev) => ({
      ...prev,
      [id]: !prev[id],
    }))
  }

  const filteredReviews = showMediaOnly
    ? mockReviews.filter((review) => review.images.length > 0 || review.hasVideo)
    : mockReviews

  return (
    <div className="py-8">
      <h3 className="mb-[20px] font-miSansDemiBold450 text-xl text-[#0F0F0F]">Reviews</h3>

      {/* 评价头部 */}
      <div className="mb-6 flex items-center justify-between">
        <h2 className="text-2xl font-medium">用户评价</h2>
        <div className="flex items-center gap-4">
          <button
            className={`rounded px-4 py-2 transition-colors ${
              !showMediaOnly ? 'bg-black text-white' : 'border border-black'
            }`}
            onClick={() => setShowMediaOnly(false)}>
            全部
          </button>
          <button
            className={`rounded px-4 py-2 transition-colors ${
              showMediaOnly ? 'bg-black text-white' : 'border border-black'
            }`}
            onClick={() => setShowMediaOnly(true)}>
            有图视频
          </button>
        </div>
      </div>

      {/* 评价列表 */}
      <div className="space-y-6">
        {filteredReviews.map((review) => (
          <div key={review.id} className="border-b border-gray-200 pb-6">
            {/* 用户信息 */}
            <div className="mb-4 flex items-center gap-3">
              <div
                className="h-10 w-10 rounded-full"
                style={{ backgroundColor: review.user.avatar }}
              />
              <div>
                <div className="font-medium">{review.user.name}</div>
                <div className="text-sm text-gray-500">{review.date}</div>
              </div>
            </div>

            {/* 评分 */}
            <div className="mb-4 flex gap-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <div
                  key={i}
                  className={`h-4 w-4 ${i < review.rating ? 'bg-black' : 'bg-gray-200'}`}
                />
              ))}
            </div>

            {/* 评价内容 */}
            <div className="mb-4">
              <p className={`text-gray-700 ${!expanded[review.id] ? 'line-clamp-3' : ''}`}>
                {review.content}
              </p>
              {review.content.length > 100 && (
                <button className="mt-2 text-gray-500" onClick={() => toggleExpand(review.id)}>
                  {expanded[review.id] ? '收起' : '展开'}
                </button>
              )}
            </div>

            {/* 图片视频 */}
            {(review.images.length > 0 || review.hasVideo) && (
              <div className="flex flex-wrap gap-2">
                {review.hasVideo && (
                  <div className="relative flex h-24 w-24 items-center justify-center bg-gray-900">
                    <div className="text-white">▶</div>
                  </div>
                )}
                {review.images.map((image, index) => (
                  <div key={index} className="h-24 w-24" style={{ backgroundColor: image }} />
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default ProductReviews
